import { Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Hidden } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { DataGrid } from "@mui/x-data-grid";
import { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ThemeContext } from "../../theme/ThemeContext";
import "./Datatable.css";
const useStyles = makeStyles((theme) => ({
  datagrid: {
    "& .MuiDataGrid-columnHeaders": {
      backgroundColor: (props) => (props.darkMode ? "#0B2E4D" : "#2286AB"),
      color: "#fff",
      borderBottom: (props) =>
        props.darkMode ? "2px solid #0B2E4D" : "2px solid #2286AB",
    },
    "& .MuiDataGrid-selectedRowCount": {
      display: "none",
    },
    "& .MuiCheckbox-root": {
      color: process.env.REACT_APP_BG_ICON,
    },
    "& .css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.Mui-checked": {
      color: process.env.REACT_APP_BG_ICON,
    },
    "& .css-1pe4mpk-MuiButtonBase-root-MuiIconButton-root": {
      color: process.env.REACT_APP_BG_TABLESORT,
    },
  },
}));

function DataTableLatest(props) {
  const { t } = useTranslation();
  const { handleChange } = props;
  const [page, setPage] = useState(1);
  const paginationRef = useRef(null);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const { darkMode } = useContext(ThemeContext);
  const classes = useStyles({ darkMode });
  const store = useSelector((state) => state);
  const loading = store.loader.loader;
  const handleRowChange = () => {
    var e = document.getElementById("pagesize");
    handleChange(1, e.value);
    setRowsPerPage(e.value);
  };

  const handlePageChange = (event, value) => {
    handleChange(value, rowsPerPage);
    setPage(value);
  };

  const calculateInitialHeight = () => {
    return window.innerHeight - 228;
  };

  const [height, setHeight] = useState(calculateInitialHeight);
  const [initialWindowHeight, setInitialWindowHeight] = useState(
    window.innerHeight,
  );

  useEffect(() => {
    const handleResize = () => {
      const percentageChange = (window.innerHeight / initialWindowHeight) * 100;
      setHeight(calculateInitialHeight);
      setInitialWindowHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [initialWindowHeight]);

  const getPage = () => {
    if (props.page != 1) {
      return 1 + (props.page - 1) * props.pageSize;
    } else {
      return 1;
    }
  };

  return (
    <>
      <Paper
        style={{
          backgroundColor: darkMode ? "#0B2E4D" : "#FFFFFF",
          borderRadius: "5px",
          boxShadow: "0px 3px 8px #00000029",
          overflow: "hidden",
          width: "100%",
        }}
      >
        <div
          style={{
            boxShadow: "0px 3px 8px #00000029",
            position: "relative",
            background: darkMode
              ? "#071724 0% 0% no-repeat padding-box"
              : "#FFFFFF 0% 0% no-repeat padding-box",
            marginLeft: props.bulkLeft ? "15px" : "",
            marginRight: props.bulkRight ? "15px" : "",
          }}
        >
          {!loading && props.rows.length === 0 ? (
            <span
              style={{
                color: darkMode ? "#fff" : "#3D4977",
                opacity: "0.8",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 1,
                fontSize: "16px",
              }}
            >
              {t("dataTableEdit1")}
            </span>
          ) : null}

          <div
            style={{
              height: props.dashboard
                ? `${height - 170}px`
                : props.dashboardPanel
                ? `${height - 135}px`
                : props.androidDeviceList
                ? `${height - 50}px`
                : props.emergencyMsg
                ? `${height - 75}px`
                : props.dailyReport
                ? `${height - 85}px`
                : props.approvals
                ? `${height - 30}px`
                : props.addAccessLevel
                ? `${height - 55}px`
                : props.transactions
                ? `${height - 20}px`
                : `${height - 5}px`,
              width: "100%",
            }}
          >
            <DataGrid
              className={classes.datagrid}
              rows={props.rows}
              columns={props.columns}
              pageSize={rowsPerPage}
              checkboxSelection={props.checkboxSelection}
              onSelectionModelChange={(ids) => {
                props.onSelectionModelChange(ids);
              }}
              disableSelectionOnClick
              hideFooterPagination
              hideFooter={props.rows.length > 0 ? false : true}
              getRowId={props.rowId}
              defaultPage={1}
              getRowClassName={(row) => {
                if (darkMode) {
                  return classes.darkModeColour;
                } else {
                  return null;
                }
              }}
              disableColumnMenu
              style={{
                color: darkMode ? "#fff" : "rgba(0, 0, 0, 0.87)",
                borderWidth: "0px",
              }}
              sx={[
                {
                  "& .MuiDataGrid-overlay": {
                    display: "none",
                  },
                  "& .MuiDataGrid-main": {
                    borderRadius: "0px !important",
                    borderStyle: "hidden !important",
                    "& > .MuiDataGrid-columnHeaders": {
                      borderTop: "none",
                      borderRadius: "0px",
                    },
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: `1px solid ${
                      darkMode ? "#1265ab21" : "#80808026"
                    } !important`,
                    color: darkMode ? "white !important" : "#000 !important",
                  },
                  "& .MuiDataGrid-row:hover": {
                    backgroundColor: darkMode
                      ? "rgba(255, 255, 255, 0.12) !important"
                      : "rgba(0, 0, 0, 0.07) !important",
                    cursor: "pointer",
                  },
                  "& .MuiDataGrid-footerContainer": {
                    minHeight: "26px",
                    borderTop: darkMode ? "none" : "",
                  },
                  "& .MuiDataGrid-iconSeparator": {
                    color: darkMode ? "#0E2A41CC" : "#2286AB",
                  },
                  "& .MuiToolbar-root": {
                    marginRight: "20px !important",
                  },
                  "& .MuiDataGrid-actionsCell .MuiIconButton-root": {
                    color: "#474a4e !important",
                  },
                },
              ]}
            />
          </div>

          <Hidden smUp>
            <Stack
              sx={{
                position: "relative",
                bottom: 12,
                width: "356px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-around",
              }}
            >
              <select
                id="pagesize"
                style={{
                  border: "1px solid #CCCCCC",
                  borderRadius: "3px",
                  opacity: 1,
                  height: "30px",
                  width: "46px",
                  opacity: 1,
                  marginTop: "3px",
                  backgroundColor: darkMode ? "red" : "#fff",
                }}
                onChange={handleRowChange}
                value={rowsPerPage}
              >
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>

              <Pagination
                size="small"
                siblingCount={0}
                ref={paginationRef}
                key={props.page}
                sx={[
                  () => ({
                    button: {
                      backgroundColor: "#F2F2F2",
                      color: "#637381",
                      minWidth: "25px",
                      height: "25px",
                    },
                  }),
                  () => ({
                    ul: {
                      "& .Mui-selected": {
                        backgroundColor: "#0E5B9D",
                        color: "white",
                      },
                      "& li": {
                        "& button:hover": {
                          backgroundColor: "rgb(79 119 171 / 40%)",
                        },
                        minWidth: "25px",
                        height: "25px",
                      },
                    },
                  }),
                  () => ({
                    ul: {
                      "&:hover": {
                        "& .Mui-selected": {
                          // backgroundColor: "#0E5B9D",
                        },
                      },
                    },
                  }),
                  () => ({
                    "& .css-1omfxuv": {
                      color: darkMode ? "white !important" : "",
                    },
                  }),
                  () => ({
                    "& .css-mpox6y-MuiPaginationItem-root": {
                      color: darkMode ? "white" : "",
                    },
                  }),
                ]}
                hidden={props?.rows?.length > 0 ? false : true}
                page={parseInt(props.page)}
                count={parseInt(props.pageCount)}
                onChange={handlePageChange}
              />
            </Stack>
          </Hidden>

          <>
            <Stack
              spacing={2}
              direction="row"
              sx={{
                position: "relative",
                bottom: 12,
                justifyContent: "flex-end",
                marginRight: "20px !important",
              }}
            >
              {props.rows.length > 0 ? (
                <>
                  <Hidden xsDown>
                    <label
                      for="records"
                      style={{
                        paddingRight: 5,
                        paddingTop: 8,
                        color: darkMode ? "#FFFFFF" : "#000000",
                      }}
                    >
                      {t("COMMON155")}{" "}
                    </label>

                    <select
                      id="pagesize"
                      style={{
                        // padding: 3,
                        // paddingBottom: 5,
                        // paddingTop: 4,
                        border: darkMode ? "1px solid #0B2E4D" : "0px solid",
                        borderRadius: "3px",
                        height: "30px",
                        width: "46px",
                        opacity: 1,
                        marginTop: "3px",
                        backgroundColor: darkMode
                          ? "#0B2E4D"
                          : "rgb(242, 242, 242)",
                        color: darkMode ? "rgba(255, 255, 255, 1)" : "",
                      }}
                      onChange={handleRowChange}
                      value={rowsPerPage}
                    >
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>
                    <p
                      style={{
                        paddingTop: 9,
                        color: darkMode ? "#FFFFFF" : "#000000",
                      }}
                    >
                      {getPage() + "-"}
                      {props.pageSize * props.page > props.count
                        ? props.count
                        : props.pageSize * props.page}
                      {" of "}
                      {props.count}{" "}
                    </p>
                  </Hidden>
                </>
              ) : (
                <div
                  style={{
                    padding: 3,
                    paddingBottom: 10,
                    paddingTop: 10,
                  }}
                >
                  <div
                    style={{
                      padding: 3,
                      paddingBottom: 5,
                      paddingTop: 5,
                    }}
                  ></div>
                </div>
              )}
              <Hidden xsDown>
                <Pagination
                  ref={paginationRef}
                  key={props.page}
                  style={{
                    marginTop: "2px",
                  }}
                  sx={[
                    () => ({
                      button: {
                        backgroundColor: "transparent",
                        color: darkMode ? "rgba(255, 255, 255, 1)" : "#637381",
                      },
                    }),
                    () => ({
                      ul: {
                        "& .Mui-selected": {
                          backgroundColor: "process.env.REACT_APP_PAGINATION",
                          color: "white",
                          backgroundColor: "#F2824C",
                        },
                        "& li": {
                          "& button:hover": {
                            backgroundColor: "rgb(79 119 171 / 40%)",
                          },
                        },
                      },
                    }),
                    () => ({
                      ul: {
                        "&:hover": {
                          "& .Mui-selected": {
                            // backgroundColor: "#0E5B9D",
                          },
                        },
                      },
                    }),
                    () => ({
                      "& .css-1omfxuv": {
                        color: darkMode ? "white !important" : "",
                      },
                    }),
                    () => ({
                      "& .css-mpox6y-MuiPaginationItem-root": {
                        color: darkMode ? "white" : "",
                      },
                    }),
                    () => ({
                      "& .MuiPaginationItem-icon": {
                        fill: "#F2824C",
                      },
                    }),
                  ]}
                  hidden={props?.rows?.length > 0 ? false : true}
                  page={parseInt(props.page)}
                  count={parseInt(props.pageCount)}
                  onChange={handlePageChange}
                />
              </Hidden>
            </Stack>
          </>
        </div>
      </Paper>
    </>
  );
}

export default DataTableLatest;

DataTableLatest.defaultProps = {
  columns: [
    {
      field: "id",
      headerName: "ID",
      flex: 1,
      minWidth: 150,
      editable: false,
    },
    {
      field: "firstName",
      headerName: "First name",
      flex: 1,
      minWidth: 150,
      editable: false,
    },
    {
      field: "fullName",
      headerName: "Full name",
      flex: 1,
      minWidth: 150,
      editable: false,
    },
    {
      field: "lastName",
      headerName: "Last name",
      flex: 1,
      minWidth: 150,
      editable: false,
    },
    {
      field: "age",
      headerName: "Age",
      flex: 1,
      minWidth: 150,
      editable: false,
    },
  ],

  rows: [],
  checkboxSelection: false,
  pageCount: 10,
};
